var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/common/helpers.ts
import { toc } from "mdast-util-toc";
import { toHast } from "mdast-util-to-hast";
import normalizeUrl from "normalize-url";
var isExternalLink = (href, origin) => {
  if (!href || !origin) {
    return false;
  }
  try {
    const baseUrl = typeof origin === "string" ? new URL(normalizeUrl(origin)) : origin;
    const hrefUrl = new URL(normalizeUrl(href));
    return hrefUrl.hostname !== baseUrl.hostname;
  } catch (e) {
    return false;
  }
};
var createYouTubeNode = id => {
  const srcDoc = "\n      <style>\n        body,\n        .youtube-embed {\n          width: 100%;\n          height: 100%;\n          margin: 0;\n          position: absolute;\n          display: flex;\n          justify-content: center;\n          object-fit: cover;\n        }\n      </style>\n\n      <a href=\"https://www.youtube-nocookie.com/embed/".concat(id, "?autoplay=1\" class=\"youtube-embed\">\n        <img src=\"https://img.youtube.com/vi/").concat(id, "/hqdefault.jpg\" alt=\"\" class=\"youtube-embed\">\n        <svg version=\"1.1\" viewBox=\"0 0 68 48\" width=\"68px\" style=\"position: relative;\">\n          <path d=\"M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z\" fill=\"#f00\"></path>\n          <path d=\"M 45,24 27,14 27,34\" fill=\"#fff\"></path>\n        </svg>\n      </a>\n    ");
  return {
    type: "element",
    tagName: "iframe",
    properties: {
      width: 800,
      height: 450,
      frameborder: "0",
      allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: true,
      srcdoc: srcDoc,
      style: "max-width: 100%; height: auto; aspect-ratio: 16/9; text-align: center;",
      "data-testid": "youtube-embed"
    },
    children: []
  };
};
var createIvoryStudioNode = url => ({
  type: "element",
  tagName: "iframe",
  properties: {
    width: 800,
    height: 450,
    loading: "lazy",
    frameborder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: true,
    src: url.href,
    style: "max-width: 100%; height: auto; aspect-ratio: 16/9; text-align: center;",
    "data-testid": "ivory-studio-embed"
  },
  children: []
});
var textNodeHandler = (_, node) => {
  if (!node.value.startsWith("http")) {
    return node;
  }
  let url;
  try {
    url = new URL(node.value);
  } catch (error) {
    console.error(error);
    return node;
  }
  const {
    host,
    pathname,
    searchParams
  } = url;
  if (host === "youtu.be") {
    const videoId = url.pathname.slice(1);
    return videoId ? createYouTubeNode(videoId) : node;
  }
  if (["youtube.com", "www.youtube.com"].includes(host)) {
    if (pathname.startsWith("/watch") && searchParams.has("v")) {
      const videoId = searchParams.get("v");
      return videoId ? createYouTubeNode(videoId) : node;
    }
    if (pathname.startsWith("/embed")) {
      const videoId = url.pathname.split("/").pop();
      return videoId ? createYouTubeNode(videoId) : node;
    }
  }
  if (host === "projects.ivorystudio.net" && pathname.includes("/embed")) {
    return createIvoryStudioNode(url);
  }
  return node;
};
var codeNodeHandler = (_, node, parent) => {
  if (!parent) {
    return node;
  }
  const tocIndex = parent.children.findIndex(child => child.type === "code" && child.lang === "toc");
  if (tocIndex === -1) {
    return node;
  }
  const result = toc(parent, {
    tight: false,
    maxDepth: 3,
    ordered: false
  });
  if (!result.map) {
    return node;
  }
  const tocHast = toHast(result.map);
  return {
    type: "element",
    tagName: "div",
    properties: {
      "data-testid": "toc",
      className: "pd-table-of-contents"
    },
    children: [{
      type: "element",
      tagName: "ul",
      properties: {},
      children: "children" in tocHast ? tocHast.children : []
      // Make sure to use the children of the HAST node
    }]
  };
};

// src/react/Markdown.tsx
import React3, { useMemo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSlug from "rehype-slug";

// src/react/ResponsiveImage.tsx
import React from "react";
import { Image as UnpicImage } from "@unpic/react";
var ResponsiveImage = _a => {
  var _b = _a,
    {
      src
    } = _b,
    rest = __objRest(_b, ["src"]);
  if (!src) return null;
  return /* @__PURE__ */React.createElement(UnpicImage, __spreadProps(__spreadValues({
    src
  }, rest), {
    layout: "fullWidth",
    breakpoints: [240, 480, 640, 830]
  }));
};
var ResponsiveImage_default = ResponsiveImage;

// src/react/Link.tsx
import React2 from "react";
var MarkdownLink = _ref => {
  let {
    href,
    isExternal,
    target,
    children
  } = _ref;
  if (isExternal) {
    return /* @__PURE__ */React2.createElement("a", {
      href,
      target: target || "_blank",
      rel: "noreferrer nofollow external"
    }, children);
  }
  return /* @__PURE__ */React2.createElement("a", {
    href,
    target
  }, children);
};
var Link_default = MarkdownLink;

// src/react/Markdown.tsx
var Markdown = _a => {
  var _b = _a,
    {
      children,
      remarkPlugins: remarkPluginsProp,
      remarkRehypeOptions: remarkRehypeOptionsProp,
      origin,
      anchorTarget
    } = _b,
    rest = __objRest(_b, ["children", "remarkPlugins", "remarkRehypeOptions", "origin", "anchorTarget"]);
  const remarkPlugins = useMemo(() => [...(remarkPluginsProp || []), remarkGfm], [remarkPluginsProp]);
  const remarkRehypeOptions = useMemo(() => __spreadProps(__spreadValues({}, remarkRehypeOptionsProp), {
    handlers: {
      text: textNodeHandler,
      code: codeNodeHandler
    }
  }), [remarkRehypeOptionsProp]);
  const components = useMemo(() => ({
    img: ResponsiveImage_default,
    // eslint-disable-next-line react/no-unstable-nested-components
    a: _ref2 => {
      let {
        href,
        children: anchorChildren
      } = _ref2;
      return /* @__PURE__ */React3.createElement(Link_default, {
        href,
        target: anchorTarget,
        isExternal: isExternalLink(href, origin)
      }, anchorChildren);
    }
  }), [origin, anchorTarget]);
  return /* @__PURE__ */React3.createElement(ReactMarkdown, __spreadValues({
    remarkPlugins,
    remarkRehypeOptions,
    rehypePlugins: [rehypeSlug],
    components
  }, rest), children);
};
var Markdown_default = Markdown;
export { Markdown_default as Markdown, codeNodeHandler, createIvoryStudioNode, createYouTubeNode, isExternalLink, textNodeHandler };